import React from 'react';
import PropTypes from 'prop-types';
import { Seq } from 'immutable';

import Brand from 'models/brand';
import TrackingProperties from 'models/tracking-properties';

import PassButton from 'components/receipt/receipt-buttons/pass-button';
import AppButton from 'components/receipt/receipt-buttons/app-button';

const propTypes = {
  bookings: PropTypes.instanceOf(Seq.Keyed),
  brand: PropTypes.instanceOf(Brand).isRequired,
  trackingProperties: PropTypes.instanceOf(TrackingProperties).isRequired,
};

const defaultProps = {
  bookings: Seq.Keyed(),
};

const ReceiptButtons = ({ authorizationCode, bookings, brand, trackingProperties }) => {
  const firstBooking = bookings.first();

  if (!firstBooking || firstBooking.isMonthly) {
    return null;
  }

  return (
    <div className="receipt-buttons clearfix hidden-print">
      <PassButton bookings={bookings} />
      <AppButton
        authorizationCode={authorizationCode}
        bookings={bookings}
        brand={brand}
        trackingProperties={trackingProperties}
      />
    </div>
  );
};

ReceiptButtons.propTypes = propTypes;
ReceiptButtons.defaultProps = defaultProps;

export default ReceiptButtons;
